<template>
    <b-collapse
        :accordion="accordion"
        :id="id"
        :visible="visible"
        @hide="$emit('hide')"
        @show="$emit('show')"
    >
        <slot />
    </b-collapse>
</template>

<script>
import { BCollapse } from 'bootstrap-vue'

export default {
    components: { BCollapse },
    props: {
        accordion: { type: String },
        id: { type: String },
        visible: { type: Boolean, default: false },
    }
}
</script>